<template>
  <div class="pagination">
    <el-pagination  @size-change="sizeChange" @current-change="currentChange" :current-page="pageNum" :page-sizes="pageSizes" :page-size="pageSize"
      layout="total,sizes,prev, pager, next, jumper" :total="total" :background="background">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    pageSizes: {
      type: Array,
      default: () => [10,20]
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageNum: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 100
    },
    background:{
       type:Boolean,
       default:false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    sizeChange (val) {
      this.$emit('sizeChange', val)
    },
    currentChange (val) {
      this.$emit('currentChange', val)
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
.pagination {
  text-align: right;
  background-color: #fff;
  border-radius: 0 0 4px 4px;
  padding: 24px !important;

}
.pagination /deep/ .el-pagination {
  font-weight: 400;
}
.pagination /deep/ .el-pagination.is-background .el-pager li {
  // background-color: #fff;
  border: 1px solid #dcdfe6;
  
}
.pagination
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #4F7AFD;
  border: 1px solid #4F7AFD;
}
.pagination /deep/ .el-pagination.is-background .btn-next {
  background-color: #fff;
  border: 1px solid #dcdfe6;
}
.pagination /deep/ .el-pagination.is-background .btn-prev {
  background-color: #fff;
  border: 1px solid #dcdfe6;
}
.pagination /deep/ .el-pagination.is-background .el-icon {
  font-weight: 400;
  font-size: 16px;
}
.pagination /deep/ .el-pagination.is-background .el-pagination__jump .el-input__inner{
  border: none;
  &:focus{
    box-shadow: none;
  }
}
@media screen and(max-width:1440px){
   .pagination /deep/ .el-pagination {
        font-weight: 400;
      }
}
</style>
